import type { ReactElement } from 'react'
import {
  dateSeparator,
  dateSeparatorLabel,
  dateSeparatorLine
} from './DateSeparator.css'

export const DateSeparator = ({ label }: { label: string }): ReactElement => (
  <div className={dateSeparator}>
    <div className={dateSeparatorLine} />
    <span className={dateSeparatorLabel}>{label}</span>
    <div className={dateSeparatorLine} />
  </div>
)
